import axiosClient from '../axiosClient';
import { CncEndpoints } from '../endpoints/cnc';
import {
  CncAwaitingDispatchItem,
  CncCustomerAtBayItem,
} from '../../types/api/response/cncresponse';

export const CncService = {
  async getAwaitingDispatch(
    warehouseId?: number,
    startDate?: string,
    endDate?: string,
  ): Promise<CncAwaitingDispatchItem[]> {
    const res = await axiosClient.get<CncAwaitingDispatchItem[]>(CncEndpoints.AWAITING_DISPATCH, {
      params: { warehouse_id: warehouseId, start_date: startDate, end_date: endDate },
    });
    return res.data;
  },

  async getCustomerAtBay(
    warehouseId?: number,
    startDate?: string,
    endDate?: string,
  ): Promise<CncCustomerAtBayItem[]> {
    const res = await axiosClient.get<CncCustomerAtBayItem[]>(CncEndpoints.CUSTOMER_AT_BAY, {
      params: { warehouse_id: warehouseId, start_date: startDate, end_date: endDate },
    });
    return res.data;
  },
};
